import {
  FormElementPlugin,
  defaultFormElementPlugins
} from '@sierralabs/forms-ui';

import { FormGroupPickerPlugin } from './FormGroupPickerPlugin';
import { FormUserPickerPlugin } from './FormUserPickerPlugin';
import { FormTableFieldPlugin } from './FormTableFieldPlugin';

export const defaultQmsFormElementPlugins: FormElementPlugin<any, any>[] = [
  ...defaultFormElementPlugins,
  FormUserPickerPlugin,
  FormGroupPickerPlugin,
  FormTableFieldPlugin
];
